export function replaceVariablesInText(
  textWithReplacements: string,
  replacements: Record<string, string | number>,
): string {
  // Create a regular expression pattern to match variables enclosed in % symbols
  const variablePattern = /%([^%]+)%/g;

  // Replace each variable in the text with its corresponding value from replacements
  const replacedText = textWithReplacements.replace(
    variablePattern,
    (_, variable) => {
      // Check if the variable exists in replacements
      if (variable in replacements) {
        return String(replacements[variable]); // Convert the value to string and return
      }
      // If the variable doesn't exist in replacements, return the original variable enclosed in %
      return `%${variable}%`;
    },
  );

  return replacedText;
}
